<script setup lang="ts">
import type { CartBoxIconControl } from "../cartBoxControls";

defineProps<{ control: CartBoxIconControl }>();
</script>

<template>
	<svg width="24" height="24" viewBox="0 0 24 24" id="custom_svg_lib" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>
